(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["_blocks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const descriptionRoot = document.querySelector("main[data-template='product'] .text-block--description_body");

    if (!descriptionRoot) return;

    const splitPattern = /\s(?:-|–|—|:)\s/;

    descriptionRoot.querySelectorAll('li').forEach((item) => {
      if (item.querySelector('.description-list-item') || item.children.length > 0) return;

      const text = item.textContent.trim();
      if (!text) return;

      const match = text.match(splitPattern);
      if (!match || match.index == null) return;

      const separatorIndex = match.index;
      const title = text.slice(0, separatorIndex).trim();
      const body = text.slice(separatorIndex + match[0].length).trim();

      if (!title || !body) return;

      item.textContent = '';

      const wrapper = document.createElement('div');
      wrapper.className = 'description-list-item';

      const titleElement = document.createElement('div');
      titleElement.className = 'description-list-item__title';
      titleElement.textContent = title;

      const bodyElement = document.createElement('div');
      bodyElement.className = 'description-list-item__body';
      bodyElement.textContent = body;

      wrapper.append(titleElement, bodyElement);
      item.appendChild(wrapper);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
